export const TABLE_STYLES = {
  root: {
    overflow: 'hidden',
    '& [class*="Table-tableWrapper"]': {
      overflow: 'hidden',
    },
    '& [class*="MuiToolbar-root"]': {
      display: 'flex',
      justifyContent: 'flex-start',
    },
    '& [class*="MuiToolbar-root"] div': {
      paddingRight: 20,
    },
    '& [class*="MuiTableHead-root"]': {
      border: 'solid 1px #e9e9e9',
      boxShadow: 'none',
    },
    '& [class*="MuiTableBody-root"]': {
      border: 'solid 1px #e9e9e9',
      boxShadow: 'none',
    },
    '& [class*="InternalTableBody-editMode"]': {
      backgroundColor: 'white',
      borderTop: 'none !important',
      borderBottom: 'none !important',
    },
    '& [class*="EmptyRow-middleAlign"]': {
      height: '90px !important',
    },

    '& [class*="EmptyRow-root"]': {
      border: 'solid 1px #e9e9e9',
      boxShadow: 'none',
      minHeight: '239px',
    },
    '& [class*="MuiFormControl-marginNormal"]': {
      marginTop: '0px',
    },
  },
};

export const FORMULA_EDITOR_CONTAINER_STYLES = {
  rootFormulaEditorContainer: {
    flex: 1,
    marginBottom: 5,
  },
};
